import {Grid} from '@mui/material';
import {makeStyles} from '@mui/styles';
import styles from 'assets/jss/AgentStyles/DashboardStyle';
const useStyles = makeStyles(styles);

const AgentBanner = () => {
  const classes = useStyles();
  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <p className={classes.welcomeTextStyle}>
            خوش آمدید!
            <br />
            <span style={{fontWeight: '400'}}>
              شما با هر بار اسکن، به پروسه درمان یک فرد، کمک می کنید.
            </span>
          </p>
          <p className={classes.startTextStyle}>
            تعداد اسکن های شما تا این لحظه :
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default AgentBanner;
